import { CableLength } from "./CableLength";
import { MFG } from "./MFG";


export class Cable {
  public constructor() {
    this.Name = "";
    this.CableType = "";
    this.BrakeLeads = false;
    this.FeedbackType = "";
    this.CableLengths = [];
    this.MFGRowPointer = "";
    this.MFG = new MFG();

    this.RowPointer = "";
    this.CreateDate = new Date();
    this.RecordDate = new Date();
    this.CreatedBy = "";
    this.UpdatedBy = "";
  }

  public Name: string;
  public CableType: string;
  public BrakeLeads: boolean;
  public CableLengths: CableLength[];  
  public MFGRowPointer: string;
  public MFG: MFG;
  //Feedback cable props
  public FeedbackType: string;

  //Syteline fields
  public RowPointer: string;
  public CreateDate: Date;
  public RecordDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
}
